import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  :root{
    --accent-1: #7c4dff; /* purple */
    --accent-2: #00d4ff; /* cyan */
    --muted: #9aa4b2;
    --bg-1: #0f1724; /* deep navy */
    --card-bg: rgba(255,255,255,0.04);
    --glass-border: rgba(255,255,255,0.06);
    --success: #23ce6b;
    --text: #e6eef6;
    --radius: 14px;
    scroll-padding-top: 10rem;
  }

  *, *::before, *::after{ box-sizing: border-box; }
  html{ font-size: 62.5%; }
  body{
    margin: 0;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: radial-gradient(1200px 600px at 10% 10%, rgba(124,77,255,0.12), transparent),
                radial-gradient(800px 400px at 90% 90%, rgba(0,212,255,0.08), transparent),
                var(--bg-1);
    color: var(--text);
    font-size: 1.6rem;
    line-height: 1.5;
  }

  a{ color: inherit; text-decoration: none; }

  ul, li { list-style: none; margin: 0; padding: 0; }

  .container{
    width: min(1200px, 92%);
    margin: 0 auto;
    padding: 6rem 0;
  }

  h1,h2,h3,h4{ color: var(--text); margin: 0 0 1.2rem 0; }

  .logo{ font-weight: 700; font-size: 3rem; }

  button, .button{
    border: none;
    cursor: pointer;
    background: linear-gradient(90deg,var(--accent-1),var(--accent-2));
    color: white;
    border-radius: 999px;
    padding: 0.9rem 1.6rem;
    font-weight: 600;
    transition: transform 180ms ease, box-shadow 180ms ease;
  }
  button:hover, .button:hover{ transform: translateY(-3px); box-shadow: 0 8px 30px rgba(12,18,26,0.45); }

  /* Section card / glass look used by multiple sections */
  .section-card{
    background: linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.02));
    border: 1px solid var(--glass-border);
    border-radius: var(--radius);
    padding: 2.4rem;
    box-shadow: 0 6px 30px rgba(2,6,23,0.6);
    backdrop-filter: blur(6px) saturate(1.05);
  }

  /* accessibility helpers */
  [role="img"]{ display: inline-block; }

  /* small utilities */
  .muted{ color: var(--muted); }

  /* keyboard focus visibility */
  :focus-visible {
    outline: 3px solid var(--accent-2);
    outline-offset: 3px;
    border-radius: 6px;
  }

  /* respect reduced motion */
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.001ms !important;
      transition-duration: 0.001ms !important;
      scroll-behavior: auto !important;
    }
    button, .button { transform: none !important; }
  }
`